import React, { useState, useRef, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './NavBar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import MobileBottomNav from './MobileBottomNav';
import MobileQuickActions from './MobileQuickActions';
import { useAuth } from '../pages/AuthContext';

const Layout = () => {
  const [collapsed, setCollapsed] = useState(true);
  const contentRef = useRef(null);
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    setCollapsed(true);
  }, [isAuthenticated]);

  useEffect(() => {
    if (contentRef.current) contentRef.current.scrollTo(0, 0);
  }, [pathname]);

  const sidebarW = collapsed ? '64px' : '208px';

  return (
    <>
      <Navbar />

      <div className="flex" style={{ paddingTop: '64px', minHeight: '100vh', background: '#F8F5EE', width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
        {/* Desktop Sidebar */}
        {isAuthenticated && (
          <div className="hidden md:block fixed left-0 hide-scrollbar"
            style={{ top: '64px', bottom: 0, zIndex: 40, width: sidebarW, transition: 'width 0.25s ease', overflowX: 'visible', overflowY: 'auto' }}>
            <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
          </div>
        )}

        {/* Circle toggle */}
        {isAuthenticated && (
          <button
            onClick={() => setCollapsed(p => !p)}
            className="hidden md:flex items-center justify-center fixed"
            style={{
              top: '50vh',
              left: `calc(${sidebarW} - 16px)`,
              transform: 'translateY(-50%)',
              width: '32px',
              height: '32px',
              zIndex: 9999,
              background: 'linear-gradient(135deg, #1e2d50, #0F172A)',
              border: '2px solid #D4AF37',
              borderRadius: '50%',
              cursor: 'pointer',
              boxShadow: '0 0 0 3px rgba(212,175,55,0.2), 0 4px 16px rgba(0,0,0,0.5)',
              transition: 'left 0.25s ease',
            }}
            onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 0 0 4px rgba(212,175,55,0.4), 0 4px 20px rgba(0,0,0,0.6)'; }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 0 0 3px rgba(212,175,55,0.2), 0 4px 16px rgba(0,0,0,0.5)'; }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
              stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"
              style={{ transition: 'transform 0.25s ease', transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
        )}

        {/* Main Content */}
        <main
          ref={contentRef}
          className="flex-1 hide-scrollbar w-full vrv-mobile-page-wrap"
          style={{ marginLeft: isAuthenticated ? undefined : '0', transition: 'margin-left 0.25s ease', maxWidth: '100%', minWidth: 0 }}>
          <style>{`
            @media (min-width: 768px) {
              main.flex-1 { margin-left: ${isAuthenticated ? sidebarW : '0'} !important; }
            }
            @media (max-width: 767px) {
              main.flex-1 { margin-left: 0 !important; }
            }
          `}</style>
          {/* Mobile Quick Actions — shown only on homepage */}
          {pathname === '/' && <MobileQuickActions />}
          <Outlet />
          <Footer />
        </main>
      </div>
      {/* Mobile Bottom Navigation */}
      <MobileBottomNav />
    </>
  );
};

export default Layout;
